import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import { ContactSupportReason } from '@enums/contact-support-reason.enum';
import { FormHelper } from '@helpers/form.helper';
import { ErrorMessage } from '@interfaces/error-message';
import { ContactSupport } from '@models/contact-support';

export interface ContactSupportFormType {
  reason: FormControl<ContactSupportReason | undefined>;
  subject: FormControl<string | undefined>;
  description: FormControl<string | undefined>;
  files: FormArray<FormControl<File>>;
  companyId: FormControl<number | undefined>;
  companyName: FormControl<string | undefined>;
  userId: FormControl<number | undefined>;
}

export class ContactSupportForm extends FormGroup<ContactSupportFormType> {
  get reason(): FormControl<ContactSupportReason | undefined> {
    return this.controls.reason;
  }

  get reasonErrorMessage(): ErrorMessage | undefined {
    return FormHelper.getEmptyErrorMessage(this.reason, 'Le motif est requis');
  }

  get subject(): FormControl<string | null> {
    return this.controls.subject;
  }

  get subjectErrorMessage(): ErrorMessage | undefined {
    return FormHelper.getEmptyErrorMessage(this.subject, 'Le sujet est requis');
  }

  get description(): FormControl<string | undefined> {
    return this.controls.description;
  }

  get descriptionErrorMessage(): ErrorMessage | null {
    return FormHelper.getEmptyErrorMessage(this.description, 'La description est requise');
  }

  get files(): FormArray<FormControl<File>> {
    return this.controls.files;
  }

  get companyId(): FormControl<number | undefined> {
    return this.controls.companyId;
  }

  get companyName(): FormControl<string | undefined> {
    return this.controls.companyName;
  }

  get userId(): FormControl<number | undefined> {
    return this.controls.userId;
  }

  constructor() {
    super({
      reason: new FormControl<ContactSupportReason | undefined>(undefined, Validators.required),
      subject: new FormControl<string | undefined>(undefined, Validators.required),
      description: new FormControl<string | undefined>(undefined, Validators.required),
      files: new FormArray<FormControl<File>>([]),
      companyId: new FormControl<number | undefined>(undefined),
      companyName: new FormControl<string | undefined>(undefined),
      userId: new FormControl<number | undefined>(undefined)
    });
  }

  toContactSupport(): ContactSupport {
    return new ContactSupport(
      this.reason.value,
      this.subject.value,
      this.description.value,
      this.files.value,
      this.companyId.value,
      this.companyName.value,
      this.userId.value
    );
  }
}
